import React from "react";
import { useTranslation } from "react-i18next";

import {
  Button
} from '@lockerpm/design';

const ChoosePlanHeader = (props) => {
  const { t } = useTranslation();
  const {
    planPeriod = {},
    selectedPeriod = {},
    setSelectedPlanDuration = () => {}
  } = props

  return (
    <div className="choose-plan-header text-center">
      <p className="text-xl font-semibold">
        {t('manage_plans.choose_plan')}
      </p>
      <p className="">
        {t('manage_plans.choose_plan_desc')}
      </p>
      <div className="flex items-center justify-center mt-3">
        <div
          style={{ border: '1px solid var(--border-color)' }}
          className="rounded-full w-[426px] p-1 flex items-center"
        >
          <Button
            className={`w-1/2 h-[48px] font-semibold ${selectedPeriod.duration === planPeriod.MONTHLY ? 'text-primary' : ''}`}
            shape="round"
            type="text"
            style={{ background: selectedPeriod.duration === planPeriod.MONTHLY ? '#e7f6e9' : ''}}
            onClick={() => setSelectedPlanDuration(planPeriod.MONTHLY)}
          >
            {t('manage_plans.bill_monthly')}
          </Button>
          <Button
            className="w-1/2 h-[48px]"
            shape="round"
            type="text"
            style={{ background: selectedPeriod.duration === planPeriod.YEARLY ? '#e7f6e9' : ''}}
            onClick={() => setSelectedPlanDuration(planPeriod.YEARLY)}
          >
            <div className="text-center">
              <p
                className={`font-semibold ${selectedPeriod.duration === planPeriod.YEARLY ? 'text-primary' : ''}`}
                style={{ lineHeight: '18px' }}
              >{t('manage_plans.bill_annually')}</p>
              <small>{t('manage_plans.bill_annually_desc')}</small>
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ChoosePlanHeader;